<template>
  <div class="entity-detail">
    <div v-if="onBack" class="entity-detail__topbar px-5">
      <div class="container">
        <button class="entity-detail__back button is-text" type="button" @click="onBack">
          <i class="fas fa-angle-left"></i>
          Regresar
        </button>
      </div>
    </div>
    <entity-details-header
      :icon="icon"
      :status="status"
      :status-labels="statusLabels"
      :title="title"
      :subtitle="subtitle"
      :registered-at="registeredAt"
      :details="details"
      :loading="loading"
    />
    <section class="section px-5 mt-5">
      <div class="container">
        <slot />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'EntityDetailLayout',
  components: {
    EntityDetailsHeader: () => import('@/components/EntityDetail/EntityDetailsHeader.vue')
  },
  props: {
    icon: {
      type: String,
      default: 'fas fa-info'
    },
    status: {
      type: Boolean,
      default: false
    },
    statusLabels: {
      type: Object,
      default: () => ({ active: 'Activo', inactive: 'Inactivo' })
    },
    title: {
      type: String,
      default: '-'
    },
    subtitle: {
      type: String,
      default: ''
    },
    registeredAt: {
      type: String,
      default: '-'
    },
    details: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    onBack: {
      type: Function,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.entity-detail {
  width: 100%;
}

.entity-detail__topbar {
  background-color: white;
  padding-top: 1rem;
  padding-bottom: 0.25rem;
}

.entity-detail__back {
  align-items: center;
  color: var(--detail-back-color);
  display: inline-flex;
  font-family: Poppins, sans-serif;
  font-size: 13px;
  gap: 0.5rem;
  height: auto;
  padding: 0;
  text-decoration: none;
}

.entity-detail__back:hover {
  color: var(--detail-back-color);
  text-decoration: none;
}
</style>
